import "../../jsx-runtime-ClSzPYp4.js";
import "react";
import "styled-components";
import "../../index.esm-DOxVcNnO.js";
import "styled-system";
import "../../Flexbox/Flexbox.mjs";
import "../../Icon/StyledPath.mjs";
import "../../LoadingSpinner/components.mjs";
import "react-dom";
import "../../typography/Heading/Heading.mjs";
import "../../typography/Link/Link.mjs";
import "../../typography/Paragraph/Paragraph.mjs";
import { COOKIE_MANAGEMENT_EVENT_ACTION as p, COOKIE_PERMISSION as i } from "../cookieManagementTypes.mjs";
import a from "./createCmapiCookiePrivacyValue.mjs";
import c from "./createNoticePopTimeValue.mjs";
import n from "./createNoticePreferencesValue.mjs";
import E from "./createDomainForCookie.mjs";
import s from "./setConsentedPolicyVersion.mjs";
import "@react-spring/web";
import "../../focus-trap-react-Bogv-_bG.js";
import "../../RadioGroup/Radio.mjs";
import "../../RadioGroup/RadioGroup.mjs";
import "../../typography/Text/Text.mjs";
import "../CookieBanner/HideOnError.mjs";
import "../FullPageCookieBanner/FullPageHideOnError.mjs";
const l = async ({ allowSiteImprovementCookies: e, allowAdvertisingCookies: t, onCookieManagementEvent: m }) => {
  m(p.SET_COOKIE_PERMISSIONS, {
    [i.CORE_FUNCTIONALITY]: !0,
    [i.SITE_IMPROVEMENT]: e,
    [i.ADVERTISING]: t
  });
  const o = new Date((/* @__PURE__ */ new Date()).setFullYear((/* @__PURE__ */ new Date()).getFullYear() + 1)).toUTCString(), r = E();
  document.cookie = `cmapi_cookie_privacy=${a({
    allowSiteImprovementCookies: e,
    allowAdvertisingCookies: t
  })}; expires=${o}; domain=${r}; path=/`, await s({
    expires: o
  }), document.cookie = `notice_preferences=${n({
    allowSiteImprovementCookies: e,
    allowAdvertisingCookies: t
  })}; expires=${o}; domain=${r}; path=/`, document.cookie = `notice_poptime=${c()}; expires=${o}; domain=${r}; path=/`;
};
export {
  l as default
};
